(function($) {

    function sidebarOpen(){
        $('html').addClass('overflow_hidden');
        $(".nav").addClass("nav-bg");
        $(".nav__sidebar").addClass("nav__sidebar--opened");
        $(".nav__hamburger-icon").addClass("nav__hamburger-icon--opened");
        $(".nav__hamburger").addClass("nav__hamburger--opened");
        // $(".nav_m__main_item:first-child").children('.nav_m__main_link').addClass("-active");
        // $(".nav_m__main_item:first-child > .nav_m__side").addClass("-hover-open");
        setTimeout(() => {
            $('body').addClass('nav-overlay')
        }, 1)
    }

    function sidebarClose(){
        $(".nav__sidebar").removeClass("nav__sidebar--opened");
        $('body').removeClass('nav-overlay');
        $(".nav").removeClass("nav-bg");
        $(".nav__hamburger-icon").removeClass("nav__hamburger-icon--opened");
        $(".nav__hamburger").removeClass("nav__hamburger--opened");
        $('html').removeClass('overflow_hidden');
        $('.nav_m__side-open').removeClass('nav_m__side-open');
        $('.nav_m__side').removeClass('-hover-open');
    }


    // Close modal on body overlay click
    $(document).on("click", "body.nav-overlay .body-content", function (e) {
        sidebarClose()
    })

    // Close modal on Escape
    $(document).keyup(function (e) {
        if (e.key === "Escape") {
            sidebarClose()
        }
    });
    $(".nav__hamburger").on("click", function () {
        if($(this).hasClass('nav__hamburger--opened')){
            sidebarClose();
        } else {
            sidebarOpen();
        }
    })
    $(".nav__close").on("click", function () {
        sidebarClose();
    })


})(jQuery);